import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=ae2ee778&scoped=true"
import script from "./Crumb.ts?vue&type=script&lang=ts&external"
export * from "./Crumb.ts?vue&type=script&lang=ts&external"
import style0 from "./Crumb.vue?vue&type=style&index=0&id=ae2ee778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2ee778",
  null
  
)

export default component.exports